import { Component, Input } from '@angular/core';
import {
  PASSWORD_POLICY_PUBLIC_HINTS,
  PERSONAL_INFO_HINT_PARTS,
  PasswordPolicyHint,
  PasswordPolicyIdentity,
  PasswordPolicyValidator
} from '../../service/password-policy/password-policy.validator';

@Component({
    standalone: false,
  selector: 'app-password-policy-hints',
  templateUrl: './password-policy-hints.component.html',
  styleUrls: ['./password-policy-hints.component.css']
})
export class PasswordPolicyHintsComponent {
  @Input() password: string;
  @Input() identity: PasswordPolicyIdentity;
  @Input() hints: PasswordPolicyHint[] = PASSWORD_POLICY_PUBLIC_HINTS;

  personalParts = PERSONAL_INFO_HINT_PARTS;

  isHintFailed(hint: PasswordPolicyHint): boolean {
    const value = this.password ? String(this.password) : '';
    if (!value) {
      return hint.requiredWhenEmpty;
    }
    const errors = PasswordPolicyValidator.evaluate(value, this.identity);
    return !!(errors && errors[hint.key]);
  }

  isPersonalPartFailed(partKey: string): boolean {
    const matched = PasswordPolicyValidator.matchedPersonalKinds(
      this.password ? String(this.password) : '',
      this.identity
    );
    return matched.indexOf(partKey) >= 0;
  }

  personalPartClass(partKey: string): string {
    return this.isPersonalPartFailed(partKey)
      ? 'policy-hints__part policy-hints__part--hit'
      : 'policy-hints__part';
  }
}
